import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    '@global': {
        '*::-webkit-scrollbar': {
            width: 9,
            height: 9,
        },

        '*::-webkit-scrollbar-button': {
            width: 0,
            height: 0,
        },

        '*::-webkit-scrollbar-thumb': {
            background: ' #FF5A60',
            border: ' 0px none transparent',
            borderRadius: 100,
        },

        '*::-webkit-scrollbar-thumb:hover': {
            background: '#af383b',
        },

        '*::-webkit-scrollbar-track': {
            background: 'transparent',
            border: ' 0px none transparent',
            borderRadius: 37,
        },

        '*::-webkit-scrollbar-corner': {
            background: 'transparent',
        },
        a: {
            textDecoration: 'none',
        },
    },
    app: {
        backgroundColor: '#FFF',
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        '& > *': {
            display: 'flex',
            flexDirection: 'column',
        },
        minHeight: '100vh',
        width: '100vw',
        padding: 0,
        margin: 0,
    },
});
